import {HintsState, IHintAnnot, IHintFamilyModel, IHintFamilyStates} from "/@lib@/edit/ot/hints.js";
import {IWedEditorMain} from "/@back@/edit/wed/wedEditor.js";
import {JSX} from "/@lib@/commons/xml/dom.js";
import {ISkAnnot} from "/@lib@/edit/schema/schemaAnnots.js";
import {POPUP} from "/@back@/commons/widgets/popups.js";

export class RemoteUrlHintFM implements IHintFamilyModel {
	key = "url"
	label = "Contrôle des URLs"

	isManual = true

	completeMsg(m: IRemoteUrlHintMsg, famSt: IRemoteUrlHintFamilyStates) {
		//m.level = EAnnotLevel.warning
		switch (m.label) {
		case "unreachable":
			m.label = "Ressource inaccessible";
			break;
		case "incompatible":
			m.label = "Nature de cette ressource incompatible";
			break;
		case "valid":
			m.label = "Ressource valide";
			m.isValid = true;
			break;
		}
		if (famSt.showValid !== m.isValid) m.result = null;
	}

	buildOptions(editor: IWedEditorMain, hintsSt: HintsState, famSt: IRemoteUrlHintFamilyStates): HTMLElement {
		const famKey = this.key;
		let countValid = 0;
		let countInvalid = 0;
		hintsSt.scanHints((h) => {
			if (h.family === famKey) {
				if ((h as IRemoteUrlHintMsg).isValid === true) countValid++; else countInvalid++;
			}
		});

		let nb = countInvalid.toString();
		const invalidStr = `${nb} lien(s) invalide(s)`;
		nb = countValid.toString();
		const validStr = `${nb} lien(s) valide(s)`;
		return <div>
			<select onchange={function onShowIgnore(this: HTMLSelectElement, ev: Event) {
				//masque cette famille.
				hintsSt.setHintsShown(famKey, false);
				famSt.showValid = this.value === "valid" ? true : undefined;
				const hints: ISkAnnot[] = [];
				hintsSt.scanHints((h) => {
					if (h.family === famKey) {
						//Si ISkAnnot.result === null, l'annot n'est pas visible.
						h.result = famSt.showValid === (h as IRemoteUrlHintMsg).isValid ? undefined : null;
						hints.push(h);
					}
				});
				//réaffiche cette famille.
				hintsSt.setHintsShown(famKey, true);
				POPUP.findPopupableParent(this)?.close(); //sinon besoin refresh de l'iput checkBox dans ce panneau de getsion des hints.
			}}>
				<option value="invalid" selected={famSt.showValid ? undefined : ""}>{invalidStr}</option>
				<option value="valid" selected={famSt.showValid ? "" : undefined}>{validStr}</option>
			</select>
			<span>/{countInvalid + countValid}</span>
		</div>;
	}
}

interface IRemoteUrlHintMsg extends IHintAnnot {
	isValid?: true
}

interface IRemoteUrlHintFamilyStates extends IHintFamilyStates {
	showValid?: true
}